"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.templates = void 0;
exports.templates = [
    "code-flow",
    "default",
    "process-flow",
    "flowchart",
    "org-chart",
    "network-diagram-dark",
    "decision-flow",
    "pert-light",
    "knowledge-graph",
    "network-diagram-icons",
    "mindmap",
    "playful-mindmap",
    "mindmap-dark",
];
